import { Controller } from "@hotwired/stimulus"
import { NavigationHelper } from "~/helpers/navigation_helper"

export default class extends Controller {
  static targets = ["container"]

  static values = { query: String }

  connect() {
    // in case the user is on a Turbo preview of the page, don't fetch the last domain searches
    if (NavigationHelper.pageIsPreview()) { return }

    this.load()
  }

  load() {
    var _this = this

    fetch("/search/last-domain-searches", { credentials: "same-origin" })
      .then(response => response.text())
      .then(html => {
        this.element.innerHTML = html

        if (_this.queryValue != "") {
          $("#domain-search-history, #domain-search-hint").hide()
        }

        $("#domain-search-history span").click(function () {
          $("#domain-field").val($(this).text())
          App.domainSearch.submit()
        })
      })
  }
}
